import script from "./EntraSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./EntraSetup.vue?vue&type=script&setup=true&lang=js"

import "./EntraSetup.vue?vue&type=style&index=0&id=4c1c4c02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1c4c02"]])

export default __exports__